export const ADSENSE_SEARCH_PAGE_TYPE = {
  ZRP: 'ZRP',
  LRP: 'LRP',
  VIP: 'VIP'
};